var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import i18next from 'i18next';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { resources } from 'utils/i18n';
import previewTypes from './constants/previewTypes';
const Preview = (_a) => {
    var { locale = 'en', type = 'MAP' } = _a, props = __rest(_a, ["locale", "type"]);
    const i18n = i18next.createInstance({
        lng: locale,
        fallbackLng: 'en',
        ns: ['translation'],
        defaultNS: 'translation',
        react: { useSuspense: false },
        interpolation: { escapeValue: false },
        resources,
    }, 
    // We must provide a function as second parameter, otherwise i18next errors
    (err) => {
        if (err)
            return console.log(err); // eslint-disable-line
    });
    const PreviewComponent = previewTypes[type];
    return (React.createElement(I18nextProvider, { i18n: i18n },
        React.createElement(PreviewComponent, Object.assign({}, props, { lang: locale }))));
};
export default Preview;
